import { usePage } from "PFApp/use_page";
import { fetchAccount, fetchCvParserConfig } from "PFCore/services/accounts/account";
import { fetchCustomTypes } from "PFCore/services/custom_types";
import { CustomType } from "PFTypes";
import { useEffect } from "react";

const initPage: InitPage = {
  cvParserConfig: null,
  customTypes: null,
  fetch: null,
  loaded: false,
  accountName: null,
  errors: []
};

type InitPage = {
  cvParserConfig: any[] | null;
  customTypes: CustomType[] | null;
  fetch: (() => void) | null;
  loaded: boolean;
  accountName: string | null;
  errors: string[];
};

export const useCvParsingConfPage = (accountId: string) => {
  const { page, setPage, mergePage, resetPage } = usePage<InitPage>(`features`, initPage);

  useEffect(() => {
    setPage(initPage);
    return resetPage;
  }, []);

  useEffect(() => {
    Promise.all([fetchCvParserConfig(accountId), fetchAccount(accountId), fetchCustomTypes(accountId)])
      .then((values) =>
        mergePage({
          cvParserConfig: values[0],
          accountName: values[1].name,
          customTypes: values[2].entries,
          loaded: true
        })
      )
      .catch(() =>
        mergePage({
          loaded: true,
          errors: ["there was an error"]
        })
      );
  }, []);

  return { ...page, fetch };
};
